module.exports = __webpack_public_path__ + "static/img/role-active.7dc7bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/role-active.png
// module id = CdVW
// module chunks = 58